import React from 'react';
import { SearchFilters } from '../../../../types/search';
import { Checkbox } from '../../../common/Checkbox';
import { TFunction } from 'i18next';

const BROADCAST_STATUS_OPTIONS = [
  { value: 'live', translationKey: 'search.broadcastStatus.live' },
  { value: 'upcoming', translationKey: 'search.broadcastStatus.upcoming' },
  { value: 'completed', translationKey: 'search.broadcastStatus.completed' }
];

interface BroadcastStatusSectionProps {
  draftFilters: SearchFilters;
  onBroadcastStatusToggle: (status: string) => void;
  t: TFunction;
}

export const BroadcastStatusSection: React.FC<BroadcastStatusSectionProps> = ({
  draftFilters,
  onBroadcastStatusToggle,
  t
}) => {
  return (
    <div className="space-y-2">
      {BROADCAST_STATUS_OPTIONS.map((option) => (
        <Checkbox
          key={option.value}
          checked={draftFilters.broadcastStatus?.includes(option.value) ?? false}
          label={t(option.translationKey)}
          onClick={() => onBroadcastStatusToggle(option.value)}
          truncate={false}
        />
      ))}
    </div>
  );
}; 